// Foto editorial sobre fundo preto + legenda e logo no rodapé.
// Composição inspirada na referência fornecida para entrevistas.
import { formatWithBoldLines } from '../shared/text'
import { LOGO_BRANCO_DATA_URI } from '../shared/logo'
import { PLACEHOLDER_IMAGE_DATA_URI } from '../shared/placeholder'
import { cropToImgStyle } from '../shared/crop'
import type { RenderContext, TemplateDefinition } from '../types'

const PHOTO_ASPECT = 560 / 616

export const CSS = `
  .tpl-foto-legenda{
    padding:0;
    overflow:hidden;
    background:#000;
    color:#fff;
  }
  .tpl-foto-legenda .photo-frame{
    position:absolute;
    top:48px;
    left:40px;
    width:560px;
    height:616px;
    overflow:hidden;
    background:#181818;
  }
  .tpl-foto-legenda .photo-frame img{display:block;}
  .tpl-foto-legenda .caption{
    position:absolute;
    left:50px;
    bottom:46px;
    width:390px;
    font-family:'Big Shoulders',sans-serif;
    font-weight:200;
    font-size:clamp(19px,var(--template-vw-4-4, 4.4vw),28px);
    line-height:1.18;
    letter-spacing:.01em;
  }
  .tpl-foto-legenda .caption b{font-weight:600;}
  .tpl-foto-legenda .logo{
    position:absolute;
    right:50px;
    bottom:59px;
    height:24px;
  }
`

function render(content: Record<string, unknown>, ctx: RenderContext = {}): string {
  const caption = formatWithBoldLines(String(content.caption ?? ''))
  const imgStyle = cropToImgStyle(ctx.imageCrop, PHOTO_ASPECT)
  const src = ctx.imageUrl || PLACEHOLDER_IMAGE_DATA_URI

  return `<section class="slide tpl-foto-legenda">
    <div class="photo-frame reveal-wipe img-reveal">
      <img src="${src}" alt="" style="${imgStyle}">
    </div>
    <p class="caption reveal r2">${caption}</p>
    <div class="logo reveal r3"><img src="${LOGO_BRANCO_DATA_URI}" alt="Lorena"></div>
  </section>`
}

export const fotoLegendaTemplate: TemplateDefinition = {
  id: 'foto-legenda',
  label: 'Foto + legenda',
  tags: ['homem', 'foto', 'texto'],
  css: CSS,
  fieldsSchema: [
    {
      key: 'caption',
      label: 'Legenda',
      type: 'textarea',
      help: 'Use **texto** para deixar um trecho em negrito.',
      placeholder: 'Hoje, à frente da empresa, o entrevistado amplia sua visão sobre **o futuro da tecnologia**.',
    },
    { key: 'image', label: 'Foto principal', type: 'image', aspectRatio: PHOTO_ASPECT },
  ],
  render,
  previewContent: {
    caption: 'Uma frase curta apresenta **o ponto central** da entrevista.',
  },
  previewCtx: { imageUrl: PLACEHOLDER_IMAGE_DATA_URI },
}
